export const GET_INQUIRY_REQUEST = "GET_INQUIRY_REQUEST"
export const GET_INQUIRY_SUCCESS = "GET_INQUIRY_SUCCESS"
export const STATUS_CHANGE_REQUEST = "STATUS_CHANGE_REQUEST"
export const STATUS_CHANGE_SUCCESS = "STATUS_CHANGE_SUCCESS"
export const DELETE_INQUIRY_REQUEST = "DELETE_INQUIRY_REQUEST"
export const DELETE_INQUIRY_SUCCESS = "DELETE_INQUIRY_SUCCESS"